div {
	/* Dimensions */
	height: 48px;
	width: 100%;
	min-width: 60px;

	/* Flex */
	display: flex;
	align-items: center;
	gap: 15px;

	/* Spacing */
	padding: 15px;

	/* Box Sizing */
	box-sizing: border-box;

	/* Border */
	border-style: solid;
	border-color: var(--border-color);
	border-width: 0px 0px 1px 0px;
}
.submenu{
	display: flex;
	flex-direction:column;
}
.sub-item{
	border: none;
}
div > p {
	margin: 0px;
	font-size: 15px;
	font-weight: normal;
}

div:hover {
	background-color: #00000009;
}

div.collapsed {
	flex-direction: column;
	justify-content: center;
	padding: 0px;
	gap: 0px;
}

div.collapsed > p {
	font-size: 10px;
	padding: 0px 4px 0px 4px;
}

.active {
	background-color: var(--card-color) !important;
}

a:link {
	text-decoration: inherit;
	color: inherit;
}

a:visited {
	text-decoration: inherit;
	color: inherit;
}

img {
	/* Dimensions */
	height: 20px;
	width: 20px;
}